module.exports = "h2 {\r\n    padding-bottom: 9px;\r\n    margin-bottom: 20px;\r\n    border-bottom: 1px solid #eee;\r\n    font-size: 16pt;\r\n    color: #343a40;\r\n}\r\n.field {\r\n    margin-bottom: 10px;\r\n}\r\n.input-btn {\r\n    display: -webkit-inline-box;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n}\r\n.label-disabled {\r\n    color: #999999;\r\n}\r\n.etiqueta {\r\n    background-color: #c6c6c6;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    margin: 10px 0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/endereco-ws-cep/endereco-ws-cep.component.css
// module id = ./src/app/endereco-ws-cep/endereco-ws-cep.component.css
// module chunks = main